import { useCrossDealProjects, useProgrammeSummaries, useActiveProfile } from "@/domain/hooks";
import { CrossDealProjectsTable } from "@/screens/shared/CrossDealProjectsTable";
import { CreateProjectAction } from "@/screens/shared/CreateProjectAction";

/**
 * Every individual project across every deal Stratus oversees, in one list -
 * reachable directly from the nav (see navSections.ts), not only after
 * clicking into a specific deal. No visibility filtering: oversight sees
 * every active deal, unlike the funder equivalent (FunderProjectsPage.tsx).
 */
export function StratusProjectsPage() {
  const profile = useActiveProfile();
  const programmes = useProgrammeSummaries();
  const { projects, isLoading, failedWorkspaceIds, refetch } = useCrossDealProjects();

  const deals = programmes.filter((p) => p.workspaceId).map((p) => ({ workspaceId: p.workspaceId as string, name: p.name }));
  const dealNameByWorkspaceId = Object.fromEntries(deals.map((d) => [d.workspaceId, d.name]));

  // UI convenience only — server enforces stratus_admin/funder_approver
  // (assertCanCreateProjectDirectly), same gate WorkspacePages.tsx's
  // showCreate uses.
  const showCreate = profile.group === "oversight" || profile.group === "funder";

  return (
    <div className="space-y-4">
      {showCreate && (
        <div className="flex justify-end">
          <CreateProjectAction deals={deals} />
        </div>
      )}
      <CrossDealProjectsTable
        projects={projects}
        dealNameByWorkspaceId={dealNameByWorkspaceId}
        isLoading={isLoading}
        failedCount={failedWorkspaceIds.length}
        onRetry={refetch}
        emptyTitle="No projects yet"
        emptyBody="Projects will appear here once a deal moves into delivery."
      />
    </div>
  );
}
